<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="visible"
      :title="title"
      center
      width="600px"
      :before-close="$onClose"
      destroy-on-close
      :auto-upload="false"
    >
      <div class="tips">导入网格文件，通过更改参数，以生成文件</div>
      <el-upload class="upload-wrap"
        name="config" drag
        :on-error="$onUploadFail"
        :on-success="$onUpload"
        action="//dev.ubanjiaoyu.com:81/start_build">
        <!-- <div class="el-upload__tip" slot="tip">导入网格文件，通过更改参数，以生成文件</div> -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'
export default {
  data() {
    return {
      URL_PATH: URL_PATH,
      visible: false,
      title: ''
    }
  },
  methods: {
    show(data) {
      this.title = data
      this.visible = true
    },
    $onClose(done) {
      done()
    },
    $onUpload(res, file, fileList) {
      console.log(res, file, fileList)
      this.$emit('toProject')
      this.visible = false
    },
    $onUploadFail(res, file, fileList) {
      console.log(res, file, fileList)
    }
  },
  created() {
    this.$root.$on('showUploadDialog', this.show)
  }
}
</script>
<style lang="less" scoped>
.upload-wrap {
  text-align: center;
}

.tips {
  font-size: 16px;
  line-height: 1;
  text-align: center;
  color: #000000;
  margin-bottom: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/uploadDialog.vue